module.exports = __webpack_public_path__ + "img/heeader.30e98800.webp";